import logo from 'assets/images/ai-warehousing.png';

function Logo() {
    return <img src={logo} alt="ai-warehousing" width="200" />;
}

export default Logo;
